<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Reporte Ventas por Producto</strong>
          </CCardHeader>
          <CCardBody>

          <b-form id="Form" autocomplete="off" @submit.prevent="GetDataProcess">
               <b-row class="row justify-content-md-center">

                <b-col sm="12" md="3">
                  <b-form-group label="Establecimiento">
                    <b-form-select v-model="report.id_establishment" :options="establishment"></b-form-select>
                  </b-form-group>
                </b-col>


                <b-col sm="12" md="2">
                  <b-form-group label="Desde :">
                    <b-form-input class="text-center" :max="report.to" type="month"  ref="to" v-model="report.from"></b-form-input>
                    <small v-if="errors.from" class="form-text text-danger" >Seleccione una fecha</small>
                  </b-form-group>
                </b-col>
                
                <b-col sm="12" md="2">
                  <b-form-group label="Hasta :">
                    <b-form-input class="text-center" :min="report.from" type="month"  ref="from" v-model="report.to"></b-form-input>
                    <small v-if="errors.to" class="form-text text-danger" >Seleccione una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group label="Periodo">
                    <b-form-select v-model="report.period" :options="period"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="3">
                  <b-form-group label="Buscar Por">
                    <b-form-input v-model="report.search"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="1">
                  <b-form-group label=".">
                    <b-button class="form-control" type="submit" variant="primary"><i class="fas fa-search"></i></b-button>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="1">
                  <b-form-group label=".">
                    <b-button class="form-control" type="button" variant="success" @click="ExportExcel"><i class="fas fa-file-excel"></i></b-button>
                  </b-form-group>
                </b-col>

            </b-row>
          </b-form>


            <div class="table-responsive mt-3">
              <table class="table table-hover  table-bordered table-container">
                <thead> 
                  <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Producto</th>
                    <th class="text-center">Categoria</th>
                    <th class="text-center">Marca</th>
                       <th v-for="period in periods" :key="period">{{ period }}</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{it + 1}}</td>
                    <td class="text-left">{{ item.code }}</td>
                    <td class="text-left">{{ item.name }}</td>
                    <td class="text-left">{{ item.category_name }}</td>
                    <td class="text-left">{{ item.brand_name }}</td>
                    <td class="text-right" v-for="(sale, it1) in item.sales" :key="it1">
                      {{ sale.total }}
                    </td>
                  </tr>
                </tbody>
               
              </table>
            </div>

  
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <LoadingComponent :is-visible="isLoading"/>
  </div>
</template>
<style>
.table-container {
    width: 100%;
    overflow-x: auto; /* Enable horizontal scrolling */
    margin-top: 20px;
    min-width: 800px; 
}

</style>
<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
var moment = require("moment");
import LoadingComponent from './../pages/Loading'

export default {
  name: "UsuarioList",
  components:{
    LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'ReportSaleProduct',
      role:1,
      data_table: [],

      unique_id: '',
      lotes: [],
      report:{
        loteSize: 200,
        id_establishment: 'all',
        from:moment().subtract(5, 'month').local().format("YYYY-MM"),
        to:moment(new Date()).local().format("YYYY-MM"),
        period:'mensual',
        search:'',
      },
      establishment:[],
      period: [
        {value:'mensual',text:'Mensual'},
        {value:'trimestral',text:'Trimestral'},
        {value:'semestral',text:'Semestral'},
        {value:'anual',text:'Anual'},
      ],
      periods:[],
      errors:{
        to:false,
        from:false,
      }
    };
  },
  mounted() {
    this.ListEstablishment();
  },
  methods: {
    ListEstablishment,
    Validate,
    Report,
    ExportExcel,
    GetDataProcess,
    SaveDataReport,

  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let id_establishment = window.localStorage.getItem("id_establishment");
      id_establishment = JSON.parse(je.decrypt(id_establishment));
      return id_establishment;
    },
  },
};

function ExportExcel() {  
  let me = this;
  if (me.unique_id.length == 0) {
        Swal.fire({ icon: 'error', text: 'Realize primero la busqueda.', timer: 2000,})
        return;
  }
  let url = me.url_base + "excel-report-sale-by-product/"+me.report.from+"/"+me.report.to+"/"+ me.report.period+"/"+ me.unique_id;
  window.open(url,'_blank');
}
function ListEstablishment() {

  let me = this;
  let url = this.url_base + "active-establishments";
  axios({
    method: "GET",
    url: url,
    headers: { token: me.token, module: me.module, role: me.role,},
  })
    .then(function (response) {
      me.establishment = [{value:'all',text:'- Todos -'}];
      if (response.data.status == 200) {
        for (let index = 0; index < response.data.result.length; index++) {
          const element = response.data.result[index];
          me.establishment.push({value: element.id_establishment, text: element.name});
        }
      } else {
        Swal.fire({ icon: 'error', text: 'A Ocurrido un error', timer: 2000,})
      }
    })
}

function Validate() {
  
  // this.errors.id_establishment = this.kardex.id_establishment.length == 0 ? true : false;
  // if (this.errors.id_establishment == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  this.Report(this);
}

function GetDataProcess() {
  let me = this;
  me.isLoading = true;
  let data = me.report;
  me.unique_id = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
  me.lotes = [];
  let url = this.url_base + "get-lotes-products";
  axios({
    method: "POST",
    url: url,
     data: data,
    headers: { token: this.token, module: this.module, role: 1,},
  }) .then(function (response) {
     if (response.data.status == 200) {
        me.lotes = response.data.result;
        me.SaveDataReport();
      } else {
        me.isLoading = false;
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      
    })
     .catch((error) => {
      console.error(error)
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}

async function SaveDataReport() {
  let me = this;
  const lotes = this.lotes;
  me.isLoading = true;
  var index = 1;
  for (const lote of lotes) {
    try {
      let data = {
        data : lote,
        id_establishment: me.report.id_establishment,
        from: me.report.from,
        to: me.report.to,
        period: me.report.period,
        unique_id: me.unique_id,
      };
      console.log(index,data)
      let url = this.url_base +"report/save-sale-by-product";
      const response = await axios({
        method: "POST",
        url: url,
        data: data,
        headers: { token: this.token, module: this.module, role: 1},
      });
       console.log('Lote: '+index, response.data.result); // Laravel envía los productos paginados dentro de "data"
       index ++;
    } catch (error) {
      me.isLoading = false;
      console.error("Error al enviar el lote:", error);
    }
  }
  me.Report();
  me.isLoading = false;
}

function Report() {
  let me = this;
  let data = {
    from: me.report.from,
    to: me.report.to,
    period: me.report.period,
    unique_id: me.unique_id,
  };
  let url = this.url_base + "report/get-sale-by-product";
  me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.periods = response.data.result.periods;
        me.data_table = response.data.result.products;
        me.isLoading = false;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
}





</script>
